import { forwardRef, type Ref, type SVGProps } from "react";

function SvgHourglass(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.375 10.25H9C8.24061 10.25 7.625 9.63439 7.625 8.875C7.625 8.11561 8.24061 7.5 9 7.5H31C31.7594 7.5 32.375 8.11561 32.375 8.875C32.375 9.63439 31.7594 10.25 31 10.25H29.625V13.5424C29.625 15.3813 28.7059 17.0986 27.1759 18.1186L22.4788 21.25L27.1758 24.3814C28.7059 25.4014 29.625 27.1187 29.625 28.9576V32.25H31C31.7594 32.25 32.375 32.8656 32.375 33.625C32.375 34.3844 31.7594 35 31 35H9C8.24061 35 7.625 34.3844 7.625 33.625C7.625 32.8656 8.24061 32.25 9 32.25H10.375V28.9576C10.375 27.1187 11.2941 25.4014 12.8241 24.3814L17.5212 21.25L12.8241 18.1186C11.2941 17.0986 10.375 15.3813 10.375 13.5424V10.25ZM13.125 10.25V13.5424C13.125 13.8287 13.1696 14.1091 13.254 14.375H26.746C26.8304 14.1091 26.875 13.8287 26.875 13.5424V10.25H13.125ZM26.875 29.5V28.9576C26.875 28.0382 26.4155 27.1795 25.6504 26.6695L20 22.9025L14.3496 26.6695C13.5845 27.1795 13.125 28.0382 13.125 28.9576V29.5H26.875Z"
        fill="currentColor"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgHourglass);
export default ForwardRef;
